export enum ITI_TIME_TRANSLATE_KEYS {
    ITI_TIME_LEAVE_NOW = 'global.itineraryTime.maintenant',
    ITI_TIME_LEAVE = 'global.itineraryTime.partir',
    ITI_TIME_ARRIVE = 'global.itineraryTime.arriver'
}
